<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-name">{{!edit ? $t('propertySpecification.creation') : $t('propertySpecification.modification')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" 
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <div class="row mb-8">
              <div class="col-12">
                <Input
                  container-class="form-group mb-5"
                  :name="`name`+id"
                  type="text"
                  :label="$t('propertySpecification.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  size="lg"
                  :isRequired="true" 
                  v-model="formData.name"
                />
              </div>
              
            </div>

          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue";
import RequiredText from "@/components/RequiredText.vue";
import { useStore } from "vuex";
import { computed } from "vue";


const store = useStore();

const emits = defineEmits(["callback"]);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  parent: {
    type: String,
    required: false,
  },
  form: {
    type: Object,
    default: () => ({
      id: "",
      name: ""
    }),
  },
  edit: {
    type: Boolean,
    default: false,
  },
});


const isLoading = ref(false);
const formData = ref({ ...props.form });


watch(
  () => props.form,
  (newForm) => {
    formData.value = { ...newForm };
  },
  { deep: true }
);

function closeModal() {
  if(props.parent){
    $("#" + props.parent).modal("toggle");
  }
  $("#" + props.id).modal("toggle");
  formData.value.name = "";
}

function submitForm() {
  isLoading.value = true;
  if (!props.edit) {
    store
      .dispatch("propertySpecifications/storePropertySpecification", formData.value)
      .then((resp) => {
        isLoading.value = false;
        emits("callback", resp.data.propertyCharacteristic);

        closeModal();
        window.toastr["success"](i18n.global.t("notification.property_specification_created"));
      })
      .catch(() => {})
      .finally(() => isLoading.value = false);
  } else {
    store.dispatch("propertySpecifications/updateProjectCategory", formData.value)
      .then(resp => {
        isLoading.value = false;
        emits("callback", resp?.data?.data);
        closeModal();

        window.toastr["success"](i18n.global.t("notification.property_specification_updated"));
      })
      .catch(() => {})
      .finally(() => isLoading.value = false);
  }
}

</script>

<style scoped>
</style>
